import { render, staticRenderFns } from "./JobRiskTable.vue?vue&type=template&id=1c2083a2&"
import script from "./JobRiskTable.vue?vue&type=script&lang=js&"
export * from "./JobRiskTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports